const EGDSHeadingTagMap = [['h1', 'h1'], ['h2', 'h2'], ['h3', 'h3'], ['h4', 'h4'], ['h5', 'h5'], ['h6', 'h6']];
const defaultMenuHeadingTag = 'h3';
const defaultMenuListHeadingTag = 'h4';
const EGDSHeadingTags = new Map(EGDSHeadingTagMap);
export { EGDSHeadingTags, defaultMenuHeadingTag, defaultMenuListHeadingTag };